import lodash from 'lodash';
import moment from 'moment';
import { apiUrl } from 'shared/config';
import { categories_skipped_in_date_search } from 'constants/Categories';
import { SUPPORTED_QUERY_PARAMS } from 'constants/PrimaryFilter';
import { MOCK_PERMISSIONS } from './documents.constants';
import * as env from 'shared/config';

export const DEFAULT_DOCUMENT_SORT_KEY = 'publication_date';
export const DEFAULT_DASH_COVID_PARAMS = {
  search_sort: DEFAULT_DOCUMENT_SORT_KEY,
  order: 'desc',
  published_from: moment().subtract(1, 'week').format('MM/DD/YYYY'),
  advanced_search: 'text = "coronavirus" OR text = "covid-19" OR text = "covid"'
};
export const DEFAULT_DASH_REGULATION_PARAMS = {
  search_sort: DEFAULT_DOCUMENT_SORT_KEY,
  order: 'desc',
  published_from: moment().subtract(1, 'week').format('MM/DD/YYYY'),
  limit: 20
};
export const DEFAULT_DASH_ALERT_WIDGET_PARAMS = {
  search_sort: DEFAULT_DOCUMENT_SORT_KEY,
  order: 'desc',
  published_from: moment().subtract(1, 'week').format('MM/DD/YYYY'),
  limit: 20
};

const typeCheckParam = param => {
  return typeof param === 'string' || typeof param === 'number';
};

export function buildUrlFromParams(params = {}, definedUrl, shouldCreateJustQueryString = false) {
  params = {
    ...params
  };

  let url = '';

  if (!shouldCreateJustQueryString) {
    url = definedUrl || `${apiUrl}/documents`;

    if (params.id) {
      url += '/' + params.id;
    }
  }

  url += '?';

  if (params.spider_name) {
    url += `spider_name=${params.spider_name}`;
  }

  if (params.folder_id) {
    url += `&folder_id=${params.folder_id}`;
    url += `&all_agencies=true`;
    url += `&all_topics=true`;
  }

  if (params.offset) {
    url += `&offset=${params.offset}`;
  }

  if (params.limit) {
    url += `&limit=${params.limit}`;
  } else if (params.folder_id) {
    url += `&limit=1000`; //FIXME: tmp high limit in folder view, add pagination later
  } else {
    url += `&limit=20`;
  }

  if (params.exclusive_fields && params.exclusive_fields.length > 0) {
    for (const field of params.exclusive_fields) {
      url += `&exclusive_fields=${field}`;
    }
  }

  if (!lodash.isNil(params.agency_id) && params.agency_id.length > 0) {
    if (typeCheckParam(params.agency_id)) {
      url += `&agency_id=${params.agency_id}`;
    } else {
      for (const agency_id of params.agency_id) {
        url += `&agency_id=${agency_id}`;
      }
    }
  }

  if (
    !lodash.isNil(params[SUPPORTED_QUERY_PARAMS.AUTHOR_ID]) &&
    params[SUPPORTED_QUERY_PARAMS.AUTHOR_ID].length > 0
  ) {
    if (typeCheckParam(params[SUPPORTED_QUERY_PARAMS.AUTHOR_ID])) {
      url += `&author_id=${params[SUPPORTED_QUERY_PARAMS.AUTHOR_ID]}`;
    } else {
      for (const authorId of params[SUPPORTED_QUERY_PARAMS.AUTHOR_ID]) {
        url += `&author_id=${authorId}`;
      }
    }
  }

  if (!lodash.isNil(params.agency) && params.agency.length > 0) {
    if (typeCheckParam(params.agency)) {
      url += `&agency_id=${params.agency}`;
    } else {
      for (const agency of params.agency) {
        url += `&agency_id=${agency}`;
      }
    }
  }

  if (!lodash.isNil(params.jurisdiction) && params.jurisdiction.length > 0) {
    if (typeCheckParam(params.jurisdiction)) {
      url += `&jurisdiction=${params.jurisdiction}`;
    } else {
      for (const jurisdiction of params.jurisdiction) {
        url += `&jurisdiction=${jurisdiction}`;
      }
    }
  }

  if (!lodash.isNil(params.news_source_id) && params.news_source_id.length > 0) {
    if (typeCheckParam(params.news_source_id)) {
      url += `&news_source_id=${params.news_source_id}`;
    } else {
      for (const news_source of params.news_source_id) {
        if (parseInt(news_source, 10)) {
          url += `&news_source_id=${news_source}`;
        }
      }
    }
  }

  if (!lodash.isNil(params.override_min_score)) {
    url += `&min_score=${params.override_min_score}`;
  } else if (!lodash.isNil(params.min_score)) {
    url += `&min_score=${params.min_score}`;
  }

  if (!lodash.isNil(params.min_score)) {
    url += `&all_agencies=true`;
    url += `&all_topics=true`;
  }

  if (!lodash.isNil(params.entity) && params.entity.length > 0) {
    if (typeCheckParam(params.entity)) {
      url += `&entity_id=${params.entity}`;
    } else {
      for (const entity of params.entity) {
        url += `&entity_id=${entity}`;
      }
    }
  }

  if (!lodash.isNil(params.skip_agency) && params.skip_agency.length > 0) {
    if (typeCheckParam(params.skip_agency)) {
      url += `&skip_agency=${params.skip_agency}`;
    } else {
      for (const agency of params.skip_agency) {
        url += `&skip_agency=${agency}`;
      }
    }
  }

  if (!lodash.isNil(params.skip_category) && params.skip_category.length > 0) {
    if (typeCheckParam(params.skip_category)) {
      url += `&skip_category=${params.skip_category}`;
    } else {
      for (const category of params.skip_category) {
        url += `&skip_category=${category}`;
      }
    }
  }

  if (!lodash.isNil(params.skip_cai_category) && params.skip_cai_category.length > 0) {
    if (typeCheckParam(params.skip_cai_category)) {
      url += `&skip_cai_category=${params.skip_cai_category}`;
    } else {
      for (const category of params.skip_cai_category) {
        url += `&skip_cai_category=${category}`;
      }
    }
  }

  if (!lodash.isNil(params.cai_category) && params.cai_category.length > 0) {
    if (!Array.isArray(params.cai_category)) {
      params.cai_category = [params.cai_category];
    }
    for (const category of params.cai_category) {
      url += `&cai_category=${category}`;
    }
  }

  if (!lodash.isNil(params.category_id) && params.category_id.length > 0) {
    if (typeCheckParam(params.category_id)) {
      params.category_id = [params.category_id];
    }
    for (const category_id of params.category_id) {
      url += `&category_id=${category_id}`;
    }
  }

  if (!lodash.isNil(params.read) && params.read.length > 0) {
    url += `&read=${params.read}`;
    //read folder/read filter view only
    if (params.read_folder_view) {
      // n.b. the api default behavior for filtering limits the list of agencies
      // we need to peel off this restriction here
      url += `&all_agencies=true`;
      url += `&all_topics=true`;
    }
  }

  if (!lodash.isNil(params.bookmarked) && params.bookmarked.length > 0) {
    url += `&bookmarked=${params.bookmarked}`;
    // n.b. the api default behavior for filtering limits the list of agencies
    // we need to peel off this restriction here
    url += `&all_agencies=true`;
    url += `&all_topics=true`;
  }

  if (!lodash.isNil(params.publication_date) && params.publication_date.length > 0) {
    url += `&publication_date=${params.publication_date}`;
  }

  if (!lodash.isNil(params.has_unofficial_publication_date)) {
    url += `&has_unofficial_publication_date=${params.has_unofficial_publication_date}`;
  }

  if (!lodash.isNil(params.published_from) && params.published_from.length > 0) {
    url += `&published_from=${params.published_from}`;
  }

  if (!lodash.isNil(params.published_to) && params.published_to.length > 0) {
    url += `&published_to=${params.published_to}`;
  }

  if (!lodash.isNil(params.created_date) && params.created_date.length > 0) {
    url += `&created_date=${params.created_date}`;
  }

  if (!lodash.isNil(params.created_from) && params.created_from.length > 0) {
    url += `&created_from=${params.created_from}`;
  }

  if (!lodash.isNil(params.created_to) && params.created_to.length > 0) {
    url += `&created_to=${params.created_to}`;
  }

  if (!lodash.isNil(params.updated_date) && params.updated_date.length > 0) {
    url += `&updated_date=${params.updated_date}`;
  }

  if (!lodash.isNil(params.updated_from) && params.updated_from.length > 0) {
    url += `&updated_from=${params.updated_from}`;
  }

  if (!lodash.isNil(params.updated_to) && params.updated_to.length > 0) {
    url += `&updated_to=${params.updated_to}`;
  }

  if (!lodash.isNil(params.effective_date) && params.effective_date.length > 0) {
    url += `&effective_date=${params.effective_date}`;
  }

  if (!lodash.isNil(params.effective_from) && params.effective_from.length > 0) {
    url += `&effective_from=${params.effective_from}`;
  }

  if (!lodash.isNil(params.effective_to) && params.effective_to.length > 0) {
    url += `&effective_to=${params.effective_to}`;
  }

  if (!lodash.isNil(params.comments_close_date) && params.comments_close_date.length > 0) {
    url += `&comments_close_date=${params.comments_close_date}`;
  }

  if (!lodash.isNil(params.comments_close_from) && params.comments_close_from.length > 0) {
    url += `&comments_close_from=${params.comments_close_from}`;
  }

  if (!lodash.isNil(params.comments_close_to) && params.comments_close_to.length > 0) {
    url += `&comments_close_to=${params.comments_close_to}`;
  }

  if (!lodash.isNil(params.sort) && params.sort.length > 0) {
    url += `&sort=${params.sort}`;
  }

  if (!lodash.isNil(params.order) && params.order.length > 0) {
    url += `&order=${params.order}`;
  }

  // temporary bag-of-words search query for 'violation'
  if (!lodash.isNil(params.violation_query) && params.violation_query.length > 0) {
    url += `&violation_query=${params.violation_query}`;
  }

  if (params.search_query) {
    url += `&query=${params.search_query}`;
  }

  if (!lodash.isNil(params.search_sort)) {
    url += `&search_sort=${params.search_sort}`;
    url += `&all_agencies=true`;
    url += `&all_topics=true`;
  }

  if (!lodash.isNil(params.topic_id) && params.topic_id.length > 0) {
    if (typeCheckParam(params.topic_id)) {
      url += `&topic_id=${params.topic_id}`;
    } else {
      for (const id of params.topic_id) {
        url += `&topic_id=${id}`;
      }
    }
  }

  if (!lodash.isNil(params.label) && params.label.length > 0) {
    if (typeCheckParam(params.label)) {
      url += `&label=${encodeURIComponent(params.label)}`;
    } else {
      for (const id of params.label) {
        url += `&label=${id}`;
      }
    }
  }

  if (!lodash.isNil(params.language_id)) {
    if (typeCheckParam(params.language_id)) {
      url += `&language_id=${params.language_id}`;
    } else {
      for (const lan_id of params.language_id) {
        url += `&language_id=${lan_id}`;
      }
    }
  }

  if (!lodash.isNil(params.regulation_id)) {
    if (typeCheckParam(params.regulation_id)) {
      url += `&regulation_id=${params.regulation_id}`;
    } else {
      for (const reg_id of params.regulation_id) {
        url += `&regulation_id=${reg_id}`;
      }
    }
  }

  if (!lodash.isNil(params.act_id) && params.act_id.length > 0) {
    if (typeCheckParam(params.act_id)) {
      url += `&act_id=${params.act_id}`;
    } else {
      for (const act of params.act_id) {
        url += `&act_id=${act}`;
      }
    }
  }

  if (!lodash.isNil(params.bank_id) && params.bank_id.length > 0) {
    if (typeCheckParam(params.bank_id)) {
      url += `&bank_id=${params.bank_id}`;
    } else {
      for (const bank of params.bank_id) {
        url += `&bank_id=${bank}`;
      }
    }
  }

  if (
    !lodash.isNil(params[SUPPORTED_QUERY_PARAMS.CONCEPT_ID]) &&
    params[SUPPORTED_QUERY_PARAMS.CONCEPT_ID].length > 0
  ) {
    if (typeCheckParam(params[SUPPORTED_QUERY_PARAMS.CONCEPT_ID])) {
      url += `&${SUPPORTED_QUERY_PARAMS.CONCEPT_ID}=${params[SUPPORTED_QUERY_PARAMS.CONCEPT_ID]}`;
    } else {
      for (const conceptId of params[SUPPORTED_QUERY_PARAMS.CONCEPT_ID]) {
        url += `&${SUPPORTED_QUERY_PARAMS.CONCEPT_ID}=${conceptId}`;
      }
    }
  }

  if (!lodash.isNil(params.citation) && params.citation.length > 0) {
    url += `&citation=${encodeURIComponent(params.citation)}`;
  }

  if (!lodash.isNil(params.citation_id_v2) && params.citation_id_v2.length > 0) {
    url += `&citation_id_v2=${encodeURIComponent(params.citation_id_v2)}`;
  }

  if (!lodash.isNil(params.internal_id) && params.internal_id.length > 0) {
    url += `&official_id=${encodeURIComponent(params.internal_id)}`;
  }

  if (!lodash.isNil(params.title) && params.title.length > 0) {
    url += `&title=${params.title}`;
  }

  if (!lodash.isNil(params.text) && params.text.length > 0) {
    url += `&text=${encodeURIComponent(params.text)}`;
  }

  if (!lodash.isNil(params.advanced_search) && params.advanced_search.length > 0) {
    url += `&advanced_search=${encodeURIComponent(params.advanced_search)}`;
  }

  if (!lodash.isNil(params.docket_id)) {
    url += `&docket_id=${params.docket_id}`;
  }

  if (!lodash.isNil(params.search_sort) && params.search_sort === 'date') {
    // n.b. the api default behavior for filtering limits the list of agencies
    // we need to peel off this restriction here
    url += `&all_agencies=true`;
    url += `&all_topics=true`;

    // we need the full text in order to do client-side highlighting
    // n.b. this will definitely slow us down.. is there another way?
    url += `&full_text=true`;

    // ensure we lodash.get the most recent documents first
    url += `&sort=publication_date&order=desc`;

    // ensure we return mentions that triggered the proposed filter match
    // so we can highlight those terms
    url += `&include_mentions_for_filter=true`;

    // only use autosuggest filters when we are in date/filter mode
    // n.b. agencies is handled separately, and leads to somewhat of a
    // doubling up effect, but i think that is probably OK

    if (!lodash.isNil(params.citation_id)) {
      url += `&citation_id=${params.citation_id}`;
    }

    for (const category of categories_skipped_in_date_search) {
      url += `&skip_category=${category}`;
    }
  }

  if (!lodash.isNil(params.query)) {
    url += `&query=${params.query}`;
  }

  if (!lodash.isNil(params.more_like_doc_id)) {
    url += `&more_like_doc_id=${params.more_like_doc_id}`;
  }
  if (!lodash.isNil(params.comments_for_id)) {
    url += `&comments_for_id=${params.comments_for_id}`;
  }

  if (!lodash.isNil(params.has_entity_respondent)) {
    url += `&has_entity_respondent=${params.has_entity_respondent}`;
  }

  if (!lodash.isNil(params.has_individual_respondent)) {
    url += `&has_individual_respondent=${params.has_individual_respondent}`;
  }

  if (!lodash.isNil(params.pdf_url)) {
    url += `&pdf_url=${params.pdf_url}`;
  }

  if (!lodash.isNil(params.all_agencies)) {
    url += `&all_agencies=${params.all_agencies}`;
  }

  if (!lodash.isNil(params.all_topics)) {
    url += `&all_topics=${params.all_topics}`;
  }

  if (!lodash.isNil(params.task_owner)) {
    url += `&task_owner=${params.task_owner}`;
  }

  if (!lodash.isNil(params.has_sentences)) {
    url += `&has_sentences=${params.has_sentences}`;
  }

  if (!lodash.isNil(params.has_annotations)) {
    url += `&has_annotations=${params.has_annotations}`;
  }

  if (!lodash.isNil(params.organization_documents_only)) {
    url += `&organization_documents_only=${params.organization_documents_only}`;
  }

  if (!lodash.isNil(params.flagged_status)) {
    url += `&flagged_status=${params.flagged_status}`;
  }

  if (!lodash.isNil(params.has_obligations)) {
    url += `&has_obligations=${params.has_obligations}`;
  }

  if (!lodash.isNil(params.is_premium_content)) {
    url += `&is_premium_content=${params.is_premium_content}`;
  }

  if (!lodash.isNil(params.is_autotranslated)) {
    url += `&is_autotranslated=${params.is_autotranslated}`;
  }

  if (!lodash.isNil(params.has_autotranslated)) {
    url += `&has_autotranslated=${params.has_autotranslated}`;
  }

  if (!lodash.isNil(params.org_related_docs_by_doc_id)) {
    url += `&org_related_docs_by_doc_id=${params.org_related_docs_by_doc_id}`;
  }

  if (!lodash.isNil(params.decorate_children)) {
    url += `&decorate_children=${params.decorate_children}`;
  }

  if (!lodash.isNil(params.resource_code)) {
    url += `&skip_fields_for_resource_code=${params.resource_code}`;
  }

  if (!lodash.isNil(params.doc_details)) {
    url += `&skip_fields_for_right_panel=${params.doc_details}`;
  }

  if (!lodash.isNil(params.size)) {
    url += `&size=${params.size}`;
  }

  // make skipping unused fields the default behavior, unless overriden
  if (lodash.isNil(params.skip_unused_fields)) {
    params.skip_unused_fields = true;
  }

  // Adding option to skip a set of fields, termed unused fields, the idea being that these fields
  // are not used by the front-end application currently, so we provide a boolean flag to toggle
  // them all off in one go to reduce the size of the payload
  if (params.skip_unused_fields) {
    url += '&skip_unused_fields=true';
  }

  if (!lodash.isNil(params.text_match_type)) {
    url += `&text_match_type=${params.text_match_type}`;
  }

  if (!lodash.isNil(params.title_match_type)) {
    url += `&title_match_type=${params.title_match_type}`;
  }

  if (!lodash.isNil(params.exclude_federal_register)) {
    url += `&exclude_federal_register=${params.exclude_federal_register}`;
  }

  if (!lodash.isNil(params.get_count_only)) {
    url += `&get_count_only=${params.get_count_only}`;
  }

  if (!lodash.isNil(params.location_id)) {
    url += `&location_id=${params.location_id}`;
  }

  if (!lodash.isNil(params.respondent) && params.respondent.length > 0) {
    // if (params.respondent) {
    url += `&respondent=${params.respondent}`;
  }

  if (!lodash.isNil(params.monetary_penalty) && params.monetary_penalty > 0) {
    url += `&monetary_penalty=${params.monetary_penalty}`;
  }

  if (!lodash.isNil(params.monetary_penalty_min) && params.monetary_penalty_min > 0) {
    url += `&monetary_penalty_min=${params.monetary_penalty_min}`;
  }

  if (!lodash.isNil(params.monetary_penalty_max) && params.monetary_penalty_max > 0) {
    url += `&monetary_penalty_max=${params.monetary_penalty_max}`;
  }

  if (params.timeline_view) {
    url += `&timeline_view=true`;
  }

  if (!lodash.isNil(params.pub_date_offset)) {
    url += `&pub_date_offset=${params.pub_date_offset}`;
  }

  if (!lodash.isNil(params.effective_on_date_offset)) {
    url += `&effective_on_date_offset=${params.effective_on_date_offset}`;
  }

  if (!lodash.isNil(params.comments_close_date_offset)) {
    url += `&comments_close_date_offset=${params.comments_close_date_offset}`;
  }

  if (params.previous_docs) {
    url += `&previous_docs=true`;
  }

  if (!lodash.isNil(params.pub_date_count)) {
    url += `&pub_date_count=${params.pub_date_count}`;
  }

  if (!lodash.isNil(params.effective_on_count)) {
    url += `&effective_on_count=${params.effective_on_count}`;
  }

  if (!lodash.isNil(params.comments_close_count)) {
    url += `&comments_close_count=${params.comments_close_count}`;
  }

  if (params.original_query_param) {
    url += `&original_query_param=true`;
  }

  if (!lodash.isNil(params.doc_id)) {
    url += `&doc_id=${params.doc_id}`;
  }

  if (!lodash.isNil(params.related_doc_id)) {
    url += `&related_doc_id=${params.related_doc_id}`;
  }

  if (!lodash.isNil(params.topic_threshold_key)) {
    url += `&topic_threshold_key=${params.topic_threshold_key}`;
  }

  if (!lodash.isNil(params.has_eitl_labels)) {
    url += `&has_eitl_labels=${params.has_eitl_labels}`;
  }

  if (!lodash.isNil(params.eitl_label_id) && params.eitl_label_id.length > 0) {
    if (typeCheckParam(params.eitl_label_id)) {
      url += `&eitl_label_id=${params.eitl_label_id}`;
    } else {
      for (const id of params.eitl_label_id) {
        url += `&eitl_label_id=${id}`;
      }
    }
  }

  if (!lodash.isNil(params[SUPPORTED_QUERY_PARAMS.DOC_ID])) {
    url += `&${[SUPPORTED_QUERY_PARAMS.DOC_ID]}=${params[SUPPORTED_QUERY_PARAMS.DOC_ID]}`;
  }

  return url;
}

export function sanitizeParams(params = {}) {
  return Object.entries(params).reduce((a, [k, v]) => (lodash.isNil(v) ? a : ((a[k] = v), a)), {});
}

export const process_combined_documents = (clear_current, state, action) => {
  const metadata = {
    isReady: true,
    isFetching: false,
    newest_dates: {
      ...state.newest_dates
    },
    oldest_dates: {
      ...state.oldest_dates
    },
    offsets: {
      ...state.offsets
    }
  };

  const combined_list = clear_current ? [] : state.combined_list;
  let offsets = {};
  let combined_count = 0;

  const new_data = action.data;
  const sort_params = Object.keys(action.data);

  let document_index;

  if (clear_current) {
    document_index = {};

    for (const sort of sort_params) {
      document_index[sort] = {};
    }
  } else {
    document_index = lodash.cloneDeep(state.document_index);
  }

  // handles the publication_date sorted documents first, because we need various
  // values populated based on the entire set before making decisions about documents
  // sorted on other fields
  // TODO: can this be re-factored a so more code can be shared?
  const has_publication_date = sort_params.indexOf('publication_date') !== -1;

  let newest_publication_date = moment(state.newest_dates.publication_date || -10e9);
  let oldest_publication_date = state.oldest_dates.publication_date
    ? moment(state.oldest_dates.publication_date)
    : moment();
  let publication_doc_count = 0;

  // hash that keeps track of which doc id and sort date pairs we've already added to
  // our list, so that when a document has effective / comments / publication dates
  // that are the same, we don't display it more than once on that specific date
  const doc_id_sort_date_mapping = {};

  // requestDocumentBefore uses this combiner too, and does not use publication_date as a sort
  // field, so we need to skip it here
  if (has_publication_date) {
    offsets = action.data.publication_date.offsets;

    for (const doc of action.data.publication_date.documents) {
      publication_doc_count += 1;

      // kind of weird, lodash.get doc.publication_date
      const sort_date = lodash.get(doc, 'publication_date');

      // occasionally the API returns documents that are missing the requested sort_date.
      // Usually happens with rule.effecitive_on
      if (!sort_date) {
        continue;
      }

      // // skip duplicate documents
      // if (document_index.publication_date[doc.id]) {
      //   continue;
      // }

      const sort_date_moment = moment(sort_date);
      const doc_id_sort_date_key = doc.id + sort_date_moment.format('YYYY-MM-DD');

      // for publication date only, we need to make sure we track the oldest date
      // since for the other sort fields, we don't want to show any of these values (unless
      // there were no results for publication_date, i.e. this is the end)
      if (sort_date && sort_date_moment.isBefore(oldest_publication_date)) {
        oldest_publication_date = sort_date_moment;
        metadata.oldest_dates.publication_date = sort_date;
      }

      if (sort_date && sort_date_moment.isAfter(newest_publication_date)) {
        newest_publication_date = sort_date_moment;
        metadata.newest_dates.publication_date = sort_date;
      }

      doc.sort_date = sort_date;
      doc.sort_basis = 'publication_date';
      document_index.publication_date[doc.id] = true;
      combined_list.push(doc);
      combined_count++;
      doc_id_sort_date_mapping[doc_id_sort_date_key] = true;
    }
  }

  for (const sort of sort_params) {
    // publication_date handled specially first above
    if (sort === 'publication_date') {
      continue;
    }

    const cur_docs = action.data[sort].documents;
    let newest_date = moment(state.newest_dates[sort] || -10e9);
    let oldest_date = state.oldest_dates[sort] ? moment(state.oldest_dates[sort]) : moment();

    for (const doc of cur_docs) {
      // kind of weird, lodash.get doc.publication_date, doc.rule.effective_on, etc
      const sort_date = lodash.get(doc, sort);

      // occasionally the API returns documents that are missing the requested sort_date.
      // Usually happens with rule.effecitive_on
      if (!sort_date) {
        continue;
      }

      // skip duplicate documents
      if (document_index[sort][doc.id]) {
        continue;
      }

      const sort_date_moment = moment(sort_date);
      const doc_id_sort_date_key = doc.id + sort_date_moment.format('YYYY-MM-DD');

      // if any document retrieved on a query sorted by effective_date or comments_close_date
      // has a document older than the oldest document sorted by publication_date, skip it
      // otherwise the user might see dates that diverge greatly from the timeline ordering
      // the oldest one that we do lodash.get gets marked below so we will always come back to these
      // everytime a user scrolls downwards, re-checking if they are in the range we care about
      // at that point.
      // n.b. the one exception being if there are no documents in the bottom-most scrolled
      // list of publication_date sorted documents, then we can just tack everything else
      // on the end
      if (
        sort_date &&
        sort_date_moment.isBefore(oldest_publication_date) &&
        publication_doc_count > 0
      ) {
        continue;
      }

      // if we have already seen this doc on this same sort date, we don't need to add it to the
      // list again, otherwise we'd end up with duplicates in the display
      if (doc_id_sort_date_mapping[doc_id_sort_date_key]) {
        continue;
      }

      if (sort_date && sort_date_moment.isAfter(newest_date)) {
        newest_date = sort_date_moment;
        metadata.newest_dates[sort] = sort_date;
      }

      // track the oldest dates so we can send date_to queries to the api to limit what we show
      if (sort_date && sort_date_moment.isBefore(oldest_date)) {
        oldest_date = sort_date_moment;
        metadata.oldest_dates[sort] = sort_date;
      }

      doc.sort_date = sort_date;
      doc.sort_basis = sort;

      document_index[sort][doc.id] = true;

      combined_list.push(doc);
      combined_count++;
      doc_id_sort_date_mapping[doc_id_sort_date_key] = true;
    }
  }

  // TODO potential optimization:
  // we can rely on the fact that each document list that we
  // receive from the api is already sorted. Instead of doing a O(N lgN)
  // sort after merging the arrays, we could do a O(N) merge operation.
  // Essentially this is half of a merge sort

  return lodash.assign({}, state, metadata, new_data, {
    count: combined_count,
    combined_list: lodash.orderBy(combined_list, 'sort_date', 'desc'),
    document_index,
    offsets
  });
};

export const extractActiveCategoryIDsByID = (categoryID, categories) =>
  categories[categoryID]?.all_active_ids ?? [];

export const getActiveCategoryIDsByIDs = (categoryIDs, categories) => {
  return categoryIDs.reduce(
    (activeIDs, categoryID) =>
      activeIDs.concat(extractActiveCategoryIDsByID(categoryID, categories)),
    []
  );
};

export const addMockPermissionsToDocs = response => {
  if (!env.shouldMockDocPermissions) {
    return response;
  }

  if (Array.isArray(response.documents)) {
    return {
      ...response,
      documents: response.documents.map(document => {
        if (document.id in MOCK_PERMISSIONS) {
          return {
            ...document,
            ...MOCK_PERMISSIONS[document.id]
          };
        }

        return document;
      })
    };
  }

  if (lodash.isObject(response.document) && response.document.id in MOCK_PERMISSIONS) {
    return {
      ...response,
      document: {
        ...response.document,
        ...MOCK_PERMISSIONS[response.document.id]
      }
    };
  }

  return response;
};
